<template>
    <div>
        <a href="https://secure.donus.org/withcan/pay/step1?_gl=1*1csn9b9*_ga*MTA5ODMyNDAzLjE3MjE4MTAwODU.*_ga_1KFQVNYJMP*MTc0Mjk2Mzc5OS4yMi4xLjE3NDI5NjU5ODYuNTkuMC4w" target="_blank" class="d-md-none">
            <v-img :src="item.mobile" alt="" />
        </a>
        <div class="d-none d-md-block">
            <v-card tile flat :img="item.image" class="bottom-banner">
                <v-container>
                    <h2 class="bottom-banner__title font-aggro" :class="item.white ? 'white--text' : ''">
                        <span class="primary">WITH-CAN,</span> 변화의 연결고리 <br />
                        세상을 바꾸는 힘, 함께할 때 시작됩니다.
                    </h2>
                    <v-btn href="https://secure.donus.org/withcan/pay/step1?_gl=1*1csn9b9*_ga*MTA5ODMyNDAzLjE3MjE4MTAwODU.*_ga_1KFQVNYJMP*MTc0Mjk2Mzc5OS4yMi4xLjE3NDI5NjU5ODYuNTkuMC4w" target="_blank" color="primary" large rounded="pill" class="mt-20 mt-md-40">
                        <span class="font-size-18 font-size-md-20 font-aggro mb-n2">위드캔복지재단과 좋은 변화 시작하기</span>
                        <v-icon small class="ml-10">mdi-chevron-right</v-icon>
                    </v-btn>
                </v-container>
            </v-card>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        item: String,
    },
};
</script>

<style lang="scss">
.bottom-banner {
    aspect-ratio: 16/9;
    display: flex;
    align-items: center;
    padding: 20px 0;
    &__title {
        font-size: 24px;
        font-weight: 500;
        > span {
            padding: 4px 0 2px;
            color: #fff;
        }
    }
}
@media (min-width: 768px) {
    .bottom-banner {
        aspect-ratio: 1920/600;
        display: flex;
        align-items: center;
        &__title {
            font-size: 36px;
            > span {
                padding: 6px 0 2px;
            }
        }
    }
}
</style>